import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { AbacusCurrency } from '@Shared/helpers';
import { formatDate } from '@Shared/helpers/abacusTimeFormatter';
import * as style from './CardTransactionRow.styl';
function renderAvatar(avatarUrl) {
    return (_jsx("div", Object.assign({ className: "circle-img" }, { children: _jsx("img", { src: avatarUrl }) })));
}
function renderAmount(amount) {
    // this can be replaced by .toFormattedString and removing the math.abs later when I'm not doing broad refactors
    const dollarAmount = new AbacusCurrency(Math.abs(amount)).getUnitValue();
    if (amount < 0) {
        return _jsxs("div", Object.assign({ className: "transaction-amount credit" }, { children: ["-$", dollarAmount] }));
    }
    return _jsxs("div", Object.assign({ className: "transaction-amount debit" }, { children: ["$", dollarAmount] }));
}
export const CardTransactionRow = (props) => {
    const { cardHolderName, avatarUrl, amount, merchant, dateMilliseconds, flagDuplicate } = props;
    const date = formatDate(dateMilliseconds, 'PP');
    const name = cardHolderName || 'Unassigned';
    const imgUrl = avatarUrl || '/img/default_avatars/u.png';
    return (_jsxs("div", Object.assign({ className: style.global }, { children: [renderAvatar(imgUrl), _jsxs("div", Object.assign({ className: "transaction-info" }, { children: [_jsxs("div", Object.assign({ className: "transaction-name-and-merchant" }, { children: [_jsx("strong", { children: name }), " at ", _jsx("strong", { children: merchant })] })), _jsxs("div", Object.assign({ className: "transaction-date-and-flags" }, { children: [_jsx("span", { children: date }), flagDuplicate && _jsx("span", Object.assign({ className: "duplicate-flag" }, { children: "Duplicate" }))] }))] })), renderAmount(amount)] })));
};
